'use client';

import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import { DEFAULT_POPUPS_TIMER } from '@/constants';
import Text from '../Text';
import Icon from '../Icon';
import SnackBarWrapper from '../Wrapper/SnackBarWrapper';

function CommonSnackBar({ title, onView, onClose, isSuccess, className = '' }) {
  const currentPath = usePathname();

  const [openModal, setOpenModal] = useState(onView);
  const { comparisonMode } = useSelector((state) => state.productComparison);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleClose = () => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(false);
    }, 200);
  };

  useEffect(() => {
    setTimeout(() => {
      handleClose();
    }, DEFAULT_POPUPS_TIMER);
  }, [openModal]);

  return (
    <SnackBarWrapper openModal={openModal} className={className}>
      <div
        className={classNames(
          'w-full lg:max-w-[720px] flex items-center justify-between gap-[6px] lg:gap-[16px] mx-8 mb-[106px] lg:mb-[32px] pr-12 pl-16 lg:pl-32 lg:pr-16 py-12 lg:py-16 rounded-[4px] transition-all duration-[400ms] shadow-cannot-be-added-modal',
          {
            'bg-cape-verde': openModal && isSuccess,
            'bg-infrared-burn': openModal && !isSuccess,
          },
          {
            'bottom-[93px] lg:bottom-0': currentPath.startsWith('/product'),
            'mb-[120px] lg:mb-[120px]': comparisonMode,
          },
        )}
      >
        <Text
          type="paragraph"
          className="text-white text-[14px] lg:text-18 font-medium leading-20 lg:leading-28 tracking-[0.28px] lg:tracking-[0.36px]"
        >
          {title}
        </Text>
        <Icon
          type="close"
          color="#fff"
          className="min-w-[24px] cursor-pointer"
          onClick={handleClose}
        />
      </div>
    </SnackBarWrapper>
  );
}

export default CommonSnackBar;
